import React from 'react';
import {Header, Button} from 'semantic-ui-react';
import makeComp from '../util/profiler';
import AccessDenied from '../components/AccessDenied';
import {isInIframe} from '../setup';
import {useViewer} from '../state/viewer/hooks';
import {login} from '../util/urls';
import config from '../config';
import {Link} from '../util/links';

interface NoMatchProps {
  unrecoverable?: boolean;
}

const NoMatch: React.FC<NoMatchProps> = makeComp(
  ({unrecoverable}) => {
    const viewer = useViewer();
    const loggedInOrOnPrem = viewer != null || config.ENVIRONMENT_IS_PRIVATE;

    const helpMessage = loggedInOrOnPrem
      ? 'If this is the right URL, you might need to ask the page owner to change the privacy permissions or invite you to the team.'
      : 'If this is the right URL, you might need to log in or ask the page owner to change the privacy permissions.';

    const buttonText = loggedInOrOnPrem ? 'Go to home page' : 'Log in to W&B';

    const buttonLink = loggedInOrOnPrem ? `/` : login({signup: true});

    return isInIframe() ? (
      <AccessDenied unrecoverable={unrecoverable} />
    ) : (
      <div className="nomatch">
        <Header>404</Header>
        <p>Looks like you stumbled on an empty page.</p>
        <p>{helpMessage}</p>
        <Link to={buttonLink} newTab={false}>
          <Button primary>{buttonText}</Button>
        </Link>
      </div>
    );
  },
  {id: 'NoMatch'}
);

export default NoMatch;
